module.exports = __webpack_public_path__ + "img/hero-dropdown-search-mitsu.e78ae822.png";